import type { CalibrationKind } from '../../../types';

type CalibrationKindLabelStrings = {
    CALIBRATION_KIND_FLOW: string;
    CALIBRATION_KIND_LEVEL: string;
    CALIBRATION_KIND_MAGNETOMETER: string;
    CALIBRATION_KIND_PUMP: string;
    CALIBRATION_KIND_WEIGHT: string;
};

export const getCalibrationKindLabels = (
    strings: CalibrationKindLabelStrings
): Record<CalibrationKind, string> => ({
    flow: strings.CALIBRATION_KIND_FLOW,
    level: strings.CALIBRATION_KIND_LEVEL,
    magnetometer: strings.CALIBRATION_KIND_MAGNETOMETER,
    pump: strings.CALIBRATION_KIND_PUMP,
    weight: strings.CALIBRATION_KIND_WEIGHT
});
